export default __webpack_public_path__ + "static/media/Square.4238811e.svg";